import { render } from "./Lens.vue?vue&type=template&id=b5a21ece"
import script from "./Lens.vue?vue&type=script&lang=ts"
export * from "./Lens.vue?vue&type=script&lang=ts"
script.render = render

export default script